import template from './employees_currently_on_leave_report.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportCurrentLeaveViewModel
{
	constructor(page)
	{
		this.page = page;
		this.employee_current_leave_list = ko.observableArray();
		this.loader = ko.observable(false);
	}

	show_report_help()
	{
		Grape.dialog.open('EmployeesCurrentlyOnLeaveHelp', {});
	}
}

class ReportCurrentLeavePage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportCurrentLeaveViewModel(this);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('EmployeesCurrentlyOnLeaveReport'))
			return;

		document.title = tr('Employees Currently On Leave');
		window.current_page_title(tr('Employees Currently On Leave'));
	}

	async updateData()
	{
		this.viewModel.loader(true);
		let res = await Grape.fetches.postJSON('/general/current_leave_list', {});

		if (typeof res === 'undefined' || !res.length)
			this.viewModel.employee_current_leave_list([]);
		else
		{
			for (let i = 0; i < res.length; i++)
			{
				res[i].fullName = res[i].firstname + ' ' + res[i].surname;
			}

			this.viewModel.employee_current_leave_list(res);
		}
		this.viewModel.loader(false);
	}
}

export default {
	route: '[/]general/current_leave_report',
	page_class: ReportCurrentLeavePage,
	template: template,
	template_filename: 'translation/employees_currently_on_leave_report'
};
